import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import CategoriesGrid from "../components/CategoriesGrid";
import FeaturedProducts from "../components/FeaturedProducts";
import TradeServices from "../components/TradeServices";
import StatsRow from "../components/StatsRow";
import WhyChooseUs from "../components/WhyChooseUs";
import SourcingCapabilities from "../components/SourcingCapabilities";
import ProcessTimeline from "../components/ProcessTimeline";
import GlobalTradeNetwork from "../components/GlobalTradeNetwork";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import InquiryForm from "../components/InquiryForm";
import ContactStrip from "../components/ContactStrip";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";

export default function Home() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <SEO />
      <Navbar />
      <div
        className={`transition-opacity duration-[600ms] ease-out ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
      >
        <main>
          <Hero />
          <AboutUs />
          <CategoriesGrid />
          <FeaturedProducts />
          <TradeServices />
          <StatsRow />
          <WhyChooseUs />
          <SourcingCapabilities />
          <ProcessTimeline />
          <GlobalTradeNetwork />
          <Testimonials />
          <FAQ />
          <InquiryForm />
          <ContactStrip />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </>
  );
}
